import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { AuthService } from '../services/auth-service/auth.service';
import { UserLanguageService } from '../services/user-language-service/user-language.service';
import {UserDashboardService} from '../user-dashboard.service';
import {formatDate} from '@angular/common';

@Component({
    selector: 'app-user-notification',
    templateUrl: './user-notification.component.html',
    styleUrls: ['./user-notification.component.scss'],
    standalone: false
})
export class UserNotificationComponent implements OnInit {

  constructor(private languageService:UserLanguageService, private authService: AuthService, private userDashboarService: UserDashboardService,
    public dialog: MatDialog, public dialogRef: MatDialogRef<UserNotificationComponent>) { }
  user: User
  userSub: Subscription;
  notifications
  labels;
  labelsSub: Subscription;
  limit
  ngOnInit(): void {
    this.labelsSub = this.languageService.labels$.subscribe((labels) =>{
      this.labels = labels;
    })

    this.userSub = this.authService.user$.subscribe((user: User) => {
      this.user = user;
    });
    this.limit = 4
    this.notifications = this.getNotifications2(this.limit)
    // this.setToSeen()
  }

  getNotifications2(limit){
    console.log("user: ", this.user)

    this.userDashboarService.fetchNotifications().subscribe((notifications) => {
      this.notifications = notifications;
      console.log("notifications: ", this.notifications)
    }, (error) => {
      console.log("notification error: ", error)
    })

  }

  loadMore(){
    this.limit += 2;
    this.getNotifications2(this.limit);
  }

  onNoClick() {
    this.dialogRef.close()
  }

  protected readonly formatDate = formatDate;
}
